import { useDispatch, useStore } from 'react-redux';
import { useMemo } from 'react';
import { ITrainingStorage } from '../lib';
import { ReducerStateShape, slice, trainingAnswersBlockSelector, trainingStateSelector } from './slice';

export const useTrainingStorage = (): ITrainingStorage => {
  const dispatch = useDispatch();
  const store = useStore<ReducerStateShape>();
  return useMemo(
    () => ({
      setAnswers: (answers) => dispatch(slice.actions.setState(answers)),
      addStepAnswer: (id, answers) => dispatch(slice.actions.addBlock({ id, answers })),
      getAnswers: () => trainingStateSelector(store.getState()),
      getBlockAnswers: (blockId) => trainingAnswersBlockSelector(store.getState(), blockId) || {},
    }),
    [store, dispatch],
  );
};
